"use client";
import React from "react";
import { Autoplay, EffectFade, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CustomGsapHeaderAnimate from "../utils/CustomGsapHeaderAnimate";

const ProjectDetailSlider = () => {
  const images = ["/assets/hindustanpurefoods/banner/millet-banner.webp"];
  return (
    <div className="rv-project-details-slider-container">
      <CustomGsapHeaderAnimate className="text-center pt-120 pb-60">
        <h2 className="rv-9-section__title rv-text-anime text-center ">
          Little Millet: The Tiny Grain with Big Benefits!
        </h2>
      </CustomGsapHeaderAnimate>
      <Swiper
        className="rv-project-details__cover-slider"
        slidesPerView={1}
        loop={true}
        effect={"fade"}
        autoplay={true}
        navigation={{
          prevEl: "#rv-project-details__cover-slider-nav .prev",
          nextEl: "#rv-project-details__cover-slider-nav .next",
        }}
        modules={[Autoplay, EffectFade, Navigation]}
      >
        {images.map((image, index) => (
          <SwiperSlide className="rv-project-details__img" key={index}>
            <img src={image} alt="Project Details Cover" />
          </SwiperSlide>
        ))}
        <div
          className="rv-1-slider-nav rv-7-slider-nav"
          id="rv-project-details__cover-slider-nav"
        >
          {/* <button title="button" className="prev">
            <i className="fa-regular fa-arrow-left"></i>
          </button>
          <button title="button" className="next">
            <i className="fa-regular fa-arrow-right"></i>
          </button> */}
        </div>
      </Swiper>
    </div>
  );
};

export default ProjectDetailSlider;
